import { connect } from 'react-redux'
import Discussion from './discussion'
import {
  isSibarOpen,
  getFetchContributionsRequest,
  getCurrentConclusion
} from '../../../../../../stores/discussion/discussion.selectors'

const mapStateToProps = state => {
  const conclusion = getCurrentConclusion(state)
  return {
    open: isSibarOpen(state),
    pending: getFetchContributionsRequest(state).pending,
    conclusionAuthor:
      conclusion && conclusion.originator && conclusion.originator.full_name,
    conclusionContent:
      conclusion && conclusion.action_object && conclusion.action_object.content
  }
}

export default connect(
  mapStateToProps,
  null
)(Discussion)
